import { Component, inject } from '@angular/core';
import { CardVariant } from '@design-system/components/m-card';
import { NavigationService } from '@portal/app/shared/services/navigation.service';
import { DashboardService } from '@portal/app/shared/services/dashboard.service';
import { TacticOptimizationsService } from '@portal/app/dashboard/context-modal/services/tactic-optimizations.service';

@Component({
  selector: 'portal-tactic-default-optimization-cards',
  templateUrl: './tactic-default-optimization-cards.component.html',
  providers: [TacticOptimizationsService],
  standalone: false
})
export class TacticDefaultOptimizationCardsComponent {
  navigationService = inject(NavigationService);
  dashboardService = inject(DashboardService);
  tacticOptimizationzService = inject(TacticOptimizationsService);

  cardVariantType = CardVariant;
  emptyStateCard = this.tacticOptimizationzService.emptyStateCard;

  onButtonAction() {
    const isMpoV2Enabled = this.dashboardService.hasMpoV2Dashboard();

    if (isMpoV2Enabled) {
      this.navigationService.navigationMapping('mpoV2', { filters: [] });
    } else {
      this.navigationService.navigationMapping(
        'mpo',
        {
          filters: [],
          extraParams: { optimizeStrengthFilterValue: 1 }
        },
        true
      );
    }
  }
}
